<script setup lang="ts">
    import { defaultRepeaterConverter } from "@/components/forms/groups/Repeater/helpers";
    import { fetchDiagnoskoder } from "@/components/forms/reusables/diagnoskodHelper";
    import { toRefs, withDefaults } from "vue";

    interface Props {
        name?: string;
    }

    const props = withDefaults(defineProps<Props>(), {
        name: "bidiagnoser",
    });

    const { name } = toRefs(props);
</script>

<template>
    <KRepeater
        :name="name"
        add-label="Lägg till bidiagnos"
        remove-label="Ta bort bidiagnos"
        :converter="defaultRepeaterConverter"
        #default="{ index, model }"
    >
        <KAutocomplete
            name="id"
            :options="fetchDiagnoskoder"
            :onSearch="fetchDiagnoskoder"
            label="Bidiagnos"
            :value="model?.[index]?.id ?? null"
            class="span-all"
            :suffixText="model?.[index]?.suffix"
        />
    </KRepeater>
</template>

<style scoped lang="scss"></style>
